import { render } from "./Blacklist.vue?vue&type=template&id=c83de888"
import script from "./Blacklist.vue?vue&type=script&lang=js"
export * from "./Blacklist.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__